import Flickity from 'flickity';

export default(() => {
    const carousels = Array.from(document.querySelectorAll('.organisation-carousel__carousel'));

    carousels.forEach((carousel) => {
        const flkty = new Flickity(carousel, {
            cellSelector: '.organisation-carousel__slide',
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            adaptiveHeight: true,
        });


        carousel.parentNode.querySelector('.organisation-carousel__pagination-prev')
            .addEventListener('click', () => {
                flkty.previous();
            });

        carousel.parentNode.querySelector('.organisation-carousel__pagination-next')
            .addEventListener('click', () => {
                flkty.next();
            });

        const slideCount = carousel.parentNode.querySelector('.organisation-carousel__count');
        slideCount.innerHTML = `${flkty.selectedIndex + 1} of ${flkty.slides.length}`;

        flkty.on('change', () => {
            slideCount.innerHTML = `${flkty.selectedIndex + 1} of ${flkty.slides.length}`;
        });

        const removeButtons = Array.from(document.querySelectorAll('.js-popup-open-remove-contact'));
        const popupFormInput = document.querySelector('#remove-contact .js-add-user-id');

        removeButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                popupFormInput.value = e.target.closest('.organisation-carousel__slide-cell').dataset.userid;
            });
        });
    });
})();
